<template>
    <div
        data-cy="fontSizeSelector-options"
        :class="
            'font-size-selector d-flex justify-center align-center py-2 px-3 ' +
            (active ? 'font-size-active' : 'font-size-non-active')
        "
        :style="`font-size: ${font_size}px`"
        @click="setConfigs"
    >
        <slot></slot>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
    props: {
        font_size: { type: [String, Number], default: '' },
        active: { type: Boolean, default: false },
        isBookFunctionality: { type: Boolean, default: false },
        isChallengeFunctionality: { type: Boolean, default: false }
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
        }),
    },
    methods: {
        ...mapActions('bookReading', ['setBookFontSize']),
        ...mapActions('challenge', ['setChallengeFontSize', 'updateConfig']),
        setConfigs() {
            if (this.isBookFunctionality) {
                this.setBookFontSize(this.font_size)
            }
            if (this.isChallengeFunctionality) {
                this.setChallengeFontSize(this.font_size)
                this.updateConfig(this.user.id)
            }
        },
    },
}
</script>
<style lang="scss">
.font-size-selector {
    background: #EEECF8;
    border-radius: 8px;
    height: 5.5vh;
    &:hover,
    &.font-size-active {
        cursor: pointer;
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
        color: white ;
    }
}
.font-size-non-active {
    background: #EEECF8;
    color: #514585;
}
</style>
